import React from 'react';
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { FormOutlined, EyeOutlined } from '@ant-design/icons';
import { Table, Row, Col, Breadcrumb, Typography, Tooltip } from 'antd';
import { intialPaginationState, showingPageTotalRange, filter, unexpectedError } from '../../common_functions';

const BookIllustrationList = props => {
  const [objects, setObjects] = useState([]);
  const [pagination, setPagination] = useState(intialPaginationState);
  const [sorter, setSorter] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
    await getObjectsData(pagination);
  })();
  }, []);
  const getObjectsData = async (pagination, filters = {}, sorter = '') => {
    try {
      setLoading(true);
      const response = await props.getBookIllustrations({
        fields: 'id,books,books.book_title,plate,image_title,negative.obj_name',
        sort: !!sorter && sorter.field ? (sorter.order === 'ascend' ? '' : '-') + sorter.field : '-id',
        filters: filters,
        offset: pagination.pageSize * (pagination.current - 1),
        limit: pagination.pageSize,
        meta: 'filter_count',
      });
      pagination.total = response.meta.filter_count;
      setPagination(pagination);
      setObjects(response.data);
    } catch (error) {
      console.error(error);
      unexpectedError(error);
    } finally {
      setLoading(false);
    }
  };
  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'id',
      key: 'id',
      render: (value, item, index) => {
        return (pagination.current - 1) * pagination.pageSize + index + 1;
      },
    },
    {
      title: 'Books',
      dataIndex: 'books',
      key: 'books',
      sorter: true,
      render: (text, record) => <span>{record.books.book_title}</span>,
      ...filter('books'),
    },
    {
      title: 'Plate',
      dataIndex: 'plate',
      key: 'plate',
      sorter: true,
      render: value => value ?? '',
      ...filter('plate'),
    },
    {
      title: 'Image Title',
      dataIndex: 'image_title',
      key: 'image_title',
      sorter: true,
      ...filter('image_title'),
    },
    {
      title: 'Negative',
      dataIndex: 'negative',
      key: 'negative',
      sorter: true,
      render: (text, record) => <span>{record?.negative?.obj_name}</span>,
      ...filter('negative'),
    },
    {
      title: 'Actions',
      key: 'action',
      render: (text, record) => (
        <span>
          <div className="actionbtngroup">
            <Link to={'/bibliography/book-illustrations/' + record.id}>
              <Tooltip
                placement="top"
                title={props.roleType === 'admin' || props?.tabs_permissions?.bibliography_book_illustrations?.edit ? 'Edit' : 'View'}
              >
                <button className="edit-btn">
                  {props.roleType === 'admin' || props?.tabs_permissions?.bibliography_book_illustrations?.edit ? (
                    <FormOutlined />
                  ) : (
                    <EyeOutlined />
                  )}
                </button>
              </Tooltip>
            </Link>
            {props.deleteRecord(
              props,
              record.id,
              'book_illustration',
              'Book illustration?',
              objects,
              setObjects,
              props?.tabs_permissions?.bibliography_book_illustrations?.delete
            )}
          </div>
        </span>
      ),
    },
  ];

  let handleTableChange = async (pagination, filters, sorter) => {
    setPagination(pagination);
    setSorter(sorter);
    setLoading(true);
    let filtersitems = {};
    for (let key in filters) {
      if (filters.hasOwnProperty(key)) {
        let val = filters[key];
        if (val) {
          filtersitems[key] =
            key === 'negative'
              ? { obj_name: { _icontains: val[0] } }
              : key === 'books'
              ? { book_title: { _icontains: val[0] } }
              : key === 'plate'
              ? { _eq: val[0] }
              : { _icontains: val[0] };
        }
      }
    }
    await getObjectsData(pagination, filtersitems, sorter);
  };

  return (
    <Row>
      <Col span={24} className="app-breadcrumb-col">
        <Breadcrumb items={[{ title: "Bibliography", href: "/bibliography/book-illustrations" }, { title: "Book Illustrations" }]} />
      </Col>
      <Col className="white-paper" span={24}>
        <div className="dashboard">
          <Row gutter={24} className="page-header-section" align="middle">
            <Col xs={12}>
              <Typography.Title level={4} style={{ margin: 0 }}>
                Book Illustration List
              </Typography.Title>
            </Col>
            <Col xs={12} justify="end">
              {props.createButton(
                props.roleType,
                props.tabs_permissions.bibliography_book_illustrations,
                `/bibliography/book-illustrations/new`,
                'Create Book Illustration'
              )}
            </Col>
          </Row>
          <hr />
          <div className="users-list">
            <Table
              rowKey="id"
              scroll={{ x: 'max-content' }}
              columns={columns}
              bordered
              dataSource={objects}
              pagination={{ ...pagination, ...showingPageTotalRange }}
              loading={loading}
              onChange={handleTableChange}
            />
          </div>
        </div>
      </Col>
    </Row>
  );
};
export default BookIllustrationList;
